import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets the window scroll to the top whenever the route changes.
 * Mount once inside <BrowserRouter> in App.js. No UI rendered.
 *
 * Skips scroll restoration when the URL contains a `#hash` anchor so deep
 * links to in-page sections still work, and when sessionStorage flags a
 * deliberate scroll-preserving navigation (e.g. back/forward from history).
 */
export default function ScrollToTop() {
  const { pathname, hash, key } = useLocation();

  useEffect(() => {
    if (hash) return; // honor in-page anchors
    // Use instant scroll for new navigations so users don't see a flash
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash, key]);

  return null;
}
